<form class="plan-form-content" (ngSubmit)="submit()">
  <div class="form-heading">
    <div>
      <span class="eyebrow">Configuración del plan</span>
      <h2>{{ plan ? 'Editar plan' : 'Nuevo plan' }}</h2>
    </div>
    <app-button class="close-button" type="button" (clicked)="cancelled.emit()" aria-label="Cerrar">
      <i class="fa-solid fa-xmark"></i>
    </app-button>
  </div>

  <p class="form-description">
    Define los datos y límites que tendrán las empresas suscritas a este plan.
  </p>

  <div class="form-grid">
    <label
      >Código interno
      <input
        name="code"
        maxlength="30"
        pattern="[A-Za-z0-9_-]{2,30}"
        [(ngModel)]="form.code"
        [disabled]="!!plan"
        placeholder="Ej. PREMIUM"
      />
    </label>
    <label
      >Nombre del plan
      <input
        name="name"
        maxlength="120"
        required
        [(ngModel)]="form.name"
        placeholder="Ej. Premium"
      />
    </label>
    <label class="full-width"
      >Descripción
      <textarea
        name="description"
        [(ngModel)]="form.description"
        maxlength="500"
        rows="3"
        placeholder="Describe brevemente el plan"
      ></textarea>
    </label>
    <label
      >Máximo de cuentas
      <input
        name="maxAccounts"
        type="number"
        min="-1"
        step="1"
        [(ngModel)]="form.maxAccounts"
      /><small>Usa -1 para cuentas ilimitadas.</small>
    </label>
    <label class="checkbox-field">
      <input name="advancedReports" type="checkbox" [(ngModel)]="form.advancedReports" /><span
        ><strong>Reportes avanzados</strong
        ><small>Habilita análisis y reportes adicionales.</small></span
      >
    </label>
    <label class="checkbox-field">
      <input name="isActive" type="checkbox" [(ngModel)]="form.isActive" />
      <span>
        <strong>Plan activo</strong>
        <small>Disponible para nuevas suscripciones.</small>
      </span>
    </label>
  </div>

  @if (error || serverError) {
    <div class="form-error">
      <i class="fa-solid fa-circle-exclamation"></i>{{ error || serverError }}
    </div>
  }

  <footer class="form-actions">
    <app-button
      class="secondary-button"
      variant="default"
      type="button"
      (clicked)="cancelled.emit()"
      >Cancelar</app-button
    >
    <app-button class="primary-button" variant="primary" type="submit" htmlType="submit">
      <i class="fa-solid fa-check"></i>{{ plan ? 'Guardar cambios' : 'Crear plan' }}
    </app-button>
  </footer>
</form>
